import { ReportApolloGrade } from "../../generated-client/apollo";

export const ApolloGrade = ReportApolloGrade.value;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ApolloGrade = ReportApolloGrade.value;

export const ApolloGradeScope = ReportApolloGrade.scope;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ApolloGradeScope = ReportApolloGrade.scope;

export const ApolloGradeScale = ReportApolloGrade.scale;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ApolloGradeScale = ReportApolloGrade.scale;

export type SunsApolloGrade = Extract<
  ApolloGrade,
  | "MINOR_LEAGUE"
  | "ROSTER"
  | "ROTATION"
  | "TOP_ROTATION"
  | "STARTER"
  | "ALL_STAR"
  | "ALL_STAR_PLUS"
  | "FRANCHISE"
>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SunsApolloGrade = {
  [ApolloGrade.MINOR_LEAGUE]: ApolloGrade.MINOR_LEAGUE,
  [ApolloGrade.ROSTER]: ApolloGrade.ROSTER,
  [ApolloGrade.ROTATION]: ApolloGrade.ROTATION,
  [ApolloGrade.TOP_ROTATION]: ApolloGrade.TOP_ROTATION,
  [ApolloGrade.STARTER]: ApolloGrade.STARTER,
  [ApolloGrade.ALL_STAR]: ApolloGrade.ALL_STAR,
  [ApolloGrade.ALL_STAR_PLUS]: ApolloGrade.ALL_STAR_PLUS,
  [ApolloGrade.FRANCHISE]: ApolloGrade.FRANCHISE,
};

export type SummerLeagueApolloGrade = Extract<
  ApolloGrade,
  "G_LEAGUE" | "EXHIBIT_10" | "TWO_WAY" | "ROSTER"
>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SummerLeagueApolloGrade = {
  [ApolloGrade.G_LEAGUE]: ApolloGrade.G_LEAGUE,
  [ApolloGrade.EXHIBIT_10]: ApolloGrade.EXHIBIT_10,
  [ApolloGrade.TWO_WAY]: ApolloGrade.TWO_WAY,
  [ApolloGrade.ROSTER]: ApolloGrade.ROSTER,
};
